import { pb } from '../../../shared/api/pocketbase';
import { Group } from './types';

// Все группы (для чекбоксов видимости разделов).
export async function fetchGroups(): Promise<Group[]> {
  return pb.collection('groups').getFullList<Group>({
    sort: 'name',
    fields: 'id,name',
    requestKey: null,
  });
}

// Группы, в которых состоит пользователь (как участник или менеджер) — для фильтра видимости.
export async function fetchMyGroupIds(userId: string): Promise<string[]> {
  const groups = await pb.collection('groups').getFullList<Group>({
    filter: `usersIds ~ "${userId}" || managers ~ "${userId}"`,
    fields: 'id',
    requestKey: null,
  });
  return groups.map(g => g.id);
}

export async function fetchManagerGroupUserIds(managerId: string): Promise<string[]> {
  const groups = await pb.collection('groups').getFullList<Group>({
    filter: `managers ~ "${managerId}"`,
    fields: 'id,usersIds',
  });

  return Array.from(new Set(groups.flatMap(group => group.usersIds ?? []).filter(Boolean)));
}
